// A boolean kept in localStorage, for per-person view preferences such as a
// collapsed panel. Reads synchronously so the panel never flashes open and then
// closes. Storage failures (private mode, quota) fall back to the default.

import { useCallback, useState } from 'react';

function read(key: string, fallback: boolean): boolean {
  try {
    const v = window.localStorage.getItem(key);
    if (v === '1') return true;
    if (v === '0') return false;
  } catch {
    // Ignore storage errors.
  }
  return fallback;
}

export function usePersistedFlag(key: string, fallback = false): [boolean, (next: boolean) => void] {
  const [state, setState] = useState<{ key: string; value: boolean }>(() => ({ key, value: read(key, fallback) }));
  // The key carries the person's email, which arrives after the session loads,
  // so re-read when it changes.
  const value = state.key === key ? state.value : read(key, fallback);
  const set = useCallback(
    (next: boolean) => {
      setState({ key, value: next });
      try {
        window.localStorage.setItem(key, next ? '1' : '0');
      } catch {
        // Ignore storage errors.
      }
    },
    [key],
  );
  return [value, set];
}
